<script lang="ts">
  import { Route } from "svelte-router-spa";
  import { Styles } from "sveltestrap";
  import Footer from "./footer.svelte";
  import Header from "./header.svelte";

  export let currentRoute;
  export let params = {};
</script>

<Styles />

<Header />
<main>
  <Route {currentRoute} {params} />
</main>
<Footer />
